import { interval } from "rxjs";
import { map, distinctUntilChanged } from "rxjs/operators";

export const CanvasSystem = (world, { updateInterval = 500 } = {}) => {
  const size$ = interval(updateInterval).pipe(
    map((i) => {
      const { width, height } = world.canvas.getBoundingClientRect();
      return { width: width, height };
    }),
    distinctUntilChanged((a, b) => {
      return !(a.width !== b.width || a.height !== b.height);
    })
  );

  size$.subscribe((size) => {
    world.size$.next(size)
    world.change$.next();
  });

  return () => {
    size$.unsubscribe();
  };
};

export default CanvasSystem;
